import { render, staticRenderFns } from "./UserGroupItem.vue?vue&type=template&id=994f0a54"
import script from "./UserGroupItem.vue?vue&type=script&lang=ts"
export * from "./UserGroupItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports